// تجربة الدخول: تظهر مرة واحدة في الجلسة (sessionStorage).
// - إن نجح Autoplay: مقدمة تلقائية قصيرة ثم اختفاء ناعم.
// - إن مُنع Autoplay: تعرض شاشة دخول بزر "دخول إلى RUSH STORE".
// تُشغّل ملف الصوت /audio/welcome.mp3 إن وُجد، وإلا تكمّل بدون صوت.
import React, { useEffect, useRef, useState } from "react";
import { Volume2, Play } from "lucide-react";
import "./WelcomeIntro.css";

const SESSION_KEY = "rush_intro_shown";
const AUDIO_MUTE_KEY = "rush_audio_muted";

const AUDIO_SRC = "/audio/welcome.mp3";

const WelcomeIntro = ({ onDone }) => {
  const [phase, setPhase] = useState("prompt"); // prompt | playing | hidden
  const [needsGesture, setNeedsGesture] = useState(false);
  const audioRef = useRef(null);
  const hideTimerRef = useRef(null);

  const alreadyShown = () => {
    try {
      return sessionStorage.getItem(SESSION_KEY) === "1";
    } catch {
      return false;
    }
  };

  useEffect(() => {
    if (alreadyShown()) {
      setPhase("hidden");
      onDone?.();
      return;
    }

    const muted = (() => {
      try {
        return sessionStorage.getItem(AUDIO_MUTE_KEY) === "1";
      } catch {
        return false;
      }
    })();

    // Try autoplay first (browsers often block audio but allow silent)
    const a = new Audio(AUDIO_SRC);
    a.preload = "auto";
    a.volume = 0.9;
    a.muted = muted;
    audioRef.current = a;

    const play = a.play();
    if (play && typeof play.then === "function") {
      play
        .then(() => {
          setPhase("playing");
          scheduleClose(2800);
        })
        .catch(() => {
          // autoplay blocked → show gesture prompt
          setNeedsGesture(true);
          setPhase("prompt");
        });
    } else {
      setPhase("playing");
      scheduleClose(2800);
    }

    return () => {
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
      const cur = audioRef.current;
      if (cur) {
        try {
          cur.pause();
        } catch {}
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scheduleClose = (ms) => {
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    hideTimerRef.current = setTimeout(() => {
      try {
        sessionStorage.setItem(SESSION_KEY, "1");
      } catch {}
      setPhase("hidden");
      onDone?.();
    }, ms);
  };

  const handleEnter = () => {
    const a = audioRef.current;
    if (a) {
      a.muted = false;
      a.currentTime = 0;
      a.play().catch(() => {});
    }
    setPhase("playing");
    setNeedsGesture(false);
    scheduleClose(2800);
  };

  if (phase === "hidden") return null;

  return (
    <div className={`welcome-intro ${phase === "playing" ? "fading" : ""}`} role="dialog" aria-modal="true">
      <div className="welcome-intro__bg" />
      <div className="welcome-intro__card">
        <div className="welcome-intro__logo">
          <span className="welcome-intro__logo-mark">
            <img
              src="/brand/rush-logo.png"
              alt="RUSH STORE"
              draggable={false}
            />
          </span>
          <span className="welcome-intro__logo-text">RUSH STORE</span>
        </div>
        <div className="welcome-intro__tag">حاسبة عجلات · COD Mobile</div>

        {needsGesture ? (
          <button
            type="button"
            data-testid="welcome-enter-btn"
            className="welcome-intro__enter"
            onClick={handleEnter}
          >
            <Play className="w-4 h-4" />
            دخول إلى RUSH STORE
          </button>
        ) : (
          <div className="welcome-intro__hint">
            <Volume2 className="w-3.5 h-3.5" />
            <span>مرحبًا بك في RUSH STORE</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default WelcomeIntro;
